export default __webpack_public_path__ + "static/media/image29.b33e25c0.png";